define('LocationsTable', ['ShippingByLocation', 'LocationsTable.View'], function LocationsTable(
  ShippingByLocation,
  LocationsTableView
) {
  'use strict';

  return {
    /**
     * @param {ComponentContainer} container
     */
    mountToApp: function mountToApp(container) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');

      this.addChildView(container, pdp.PDP_QUICK_VIEW);
      this.addChildView(container, pdp.PDP_FULL_VIEW);
    },
    /**
     * @param {ComponentContainer} container
     * @param {String} viewId
     */
    addChildView: function addChildView(container, viewId) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');
      var environment = container.getComponent('Environment');

      pdp.addChildViews(viewId, {
        'Product.Information': {
          LocationsTable: {
            childViewIndex: -1,
            childViewConstructor: function LocationsTableViewConstructor() {
              var model = ShippingByLocation.forCurrentProduct(container);
              var view = new LocationsTableView({
                environment: environment,
                model: model,
                pdp: pdp
              });
              model.setup().done(function doneLoad() {
                view.render();
              });
              return view;
            }
          }
        }
      });
    }
  };
});
